
export enum TextTokenEnum {
    AllRightsReserved = "AllRightsReserved",
    BookingForm_WantYourOwnTinyCalBookingPage = "BookingForm_WantYourOwnTinyCalBookingPage",
    BookingForm_ClickHere = "BookingForm_ClickHere",
    BookingForm_SelectAService = "BookingForm_SelectAService",
    BookingForm_SelectATeamMember = "BookingForm_SelectATeamMember",
    BookingForm_Minutes = "BookingForm_Minutes",
    BookingForm_ShowLessDates = "BookingForm_ShowLessDates",
    BookingForm_ShowMoreDates = "BookingForm_ShowMoreDates",
    BookingForm_UpTo = "BookingForm_UpTo",
    BookingForm_RecurringMeetings = "BookingForm_RecurringMeetings",
    BookingForm_SelectADateAndTime = "BookingForm_SelectADateAndTime",
    BookingForm_PageTitle_Services = "BookingForm_PageTitle_Services",
    BookingForm_PageTitle_TeamMember = "BookingForm_PageTitle_TeamMember",
    BookingForm_PageTitle_DateAndTime = "BookingForm_PageTitle_DateAndTime",
    BookingForm_PageTitle_Confirmation = "BookingForm_PageTitle_Confirmation",
    BookingForm_PageTitle_MeetingConfirmed = "BookingForm_PageTitle_MeetingConfirmed",
    BookingForm_SUN = "BookingForm_SUN",
    BookingForm_MON = "BookingForm_MON",
    BookingForm_TUE = "BookingForm_TUE",
    BookingForm_WED = "BookingForm_WED",
    BookingForm_THU = "BookingForm_THU",
    BookingForm_FRI = "BookingForm_FRI",
    BookingForm_SAT = "BookingForm_SAT",
    BookingForm_January = "BookingForm_January",
    BookingForm_February = "BookingForm_February",
    BookingForm_March = "BookingForm_March",
    BookingForm_April = "BookingForm_April",
    BookingForm_May = "BookingForm_May",
    BookingForm_June = "BookingForm_June",
    BookingForm_July = "BookingForm_July",
    BookingForm_August = "BookingForm_August",
    BookingForm_September = "BookingForm_September",
    BookingForm_October = "BookingForm_October",
    BookingForm_November = "BookingForm_November",
    BookingForm_December = "BookingForm_December",
    BookingForm_Continue = "BookingForm_Continue",
    BookingForm_ConfirmMeetingDetails = "BookingForm_ConfirmMeetingDetails",
    BookingForm_LoginWithGoogle = "BookingForm_LoginWithGoogle",
    BookingForm_Name = "BookingForm_Name",
    BookingForm_Email = "BookingForm_Email",
    BookingForm_NumberOfBookings = "BookingForm_NumberOfBookings",
    BookingForm_Notes = "BookingForm_Notes",
    BookingForm_Location = "BookingForm_Location",
    BookingForm_BookMeeting = "BookingForm_BookMeeting",
    BookingForm_Questions = "BookingForm_Questions",
    BookingForm_PaymentDetails = "BookingForm_PaymentDetails",
    BookingForm_Currency = "BookingForm_Currency",
    BookingForm_Total = "BookingForm_Total",
    BookingForm_SavePaymentMethod = "BookingForm_SavePaymentMethod",
    BookingForm_SaveThisPaymentMethodForFutureUsage = "BookingForm_SaveThisPaymentMethodForFutureUsage",
    BookingForm_GoogleMeet = "BookingForm_GoogleMeet",
    BookingForm_Zoom = "BookingForm_Zoom",
    BookingForm_Phone = "BookingForm_Phone",
    BookingForm_InPersonHostDefined = "BookingForm_InPersonHostDefined",
    BookingForm_InPersonAttendeeDefined = "BookingForm_InPersonAttendeeDefined",
    BookingForm_Country = "BookingForm_Country",
    BookingForm_PhoneOnlyNumbers = "BookingForm_PhoneOnlyNumbers",
    BookingForm_Address = "BookingForm_Address",
    BookingForm_MeetingSuccessfullyBooked = "BookingForm_MeetingSuccessfullyBooked",
    BookingForm_YouCanFindTheDetailsBelow = "BookingForm_YouCanFindTheDetailsBelow",
    BookingForm_NeedToRescheduleOrCancelThisMeeting = "BookingForm_NeedToRescheduleOrCancelThisMeeting",
    Meeting_RescheduleOrCancelMeeting = "Meeting_RescheduleOrCancelMeeting",
    Meeting_Scheduled = "Meeting_Scheduled",
    Meeting_Recurring = "Meeting_Recurring",
    Meeting_Paid = "Meeting_Paid",
    Meeting_Group = "Meeting_Group",
    Meeting_Refunded = "Meeting_Refunded",
    Meeting_Meeting = "Meeting_Meeting",
    Meeting_Mins = "Meeting_Mins",
    Meeting_empty = "Meeting_empty",
    Meeting_Reschedule = "Meeting_Reschedule",
    Meeting_Cancel = "Meeting_Cancel",
    Meeting_CancelAllMeetings = "Meeting_CancelAllMeetings",
    Meeting_AreYouSureYouWantToCancelTheMeeting = "Meeting_AreYouSureYouWantToCancelTheMeeting",
    Meeting_ThisActionIsIrreversible = "Meeting_ThisActionIsIrreversible",
    Meeting_YesCancel = "Meeting_YesCancel",
    Meeting_RescheduleMeeting = "Meeting_RescheduleMeeting",
}

export enum LocaleEnum {
    English = "English",
    Polish = "Polish",
    Spanish = "Spanish",
    German = "German",
    Italian = "Italian",
    French = "French",
    Portuguese_Portugal = "Portuguese_Portugal",
    Portuguese_Brazil = "Portuguese_Brazil",
}

export const LocaleEnumData = {
    [LocaleEnum.English]: {
        key: LocaleEnum.English,
        value: "English",
        label: "English",
        stripeShortLocale: 'en',
        nativeLanguageLabel: 'English',
    },
    [LocaleEnum.Polish]: {
        key: LocaleEnum.Polish,
        value: "Polish",
        label: "Polish",
        stripeShortLocale: 'pl',
        nativeLanguageLabel: 'Polski',
    },
    [LocaleEnum.Spanish]: {
        key: LocaleEnum.Spanish,
        value: "Spanish",
        label: "Spanish",
        stripeShortLocale: 'es',
        nativeLanguageLabel: 'Española',
    },
    [LocaleEnum.German]: {
        key: LocaleEnum.German,
        value: "German",
        label: "German",
        stripeShortLocale: 'de',
        nativeLanguageLabel: 'Deutsch',
    },
    [LocaleEnum.Italian]: {
        key: LocaleEnum.Italian,
        value: "Italian",
        label: "Italian",
        stripeShortLocale: 'it',
        nativeLanguageLabel: 'Italiano',
    },
    [LocaleEnum.French]: {
        key: LocaleEnum.French,
        value: "French",
        label: "French",
        stripeShortLocale: 'fr',
        nativeLanguageLabel: 'Français',
    },
    [LocaleEnum.Portuguese_Portugal]: {
        key: LocaleEnum.Portuguese_Portugal,
        value: "Portuguese_Portugal",
        label: "Portuguese_Portugal",
        stripeShortLocale: 'pt',
        nativeLanguageLabel: 'Português (PT)',
    },
    [LocaleEnum.Portuguese_Brazil]: {
        key: LocaleEnum.Portuguese_Brazil,
        value: "Portuguese_Brazil",
        label: "Portuguese_Brazil",
        stripeShortLocale: 'pt-BR',
        nativeLanguageLabel: 'Português (BR)',
    },
} as const

export const LocaleEnumList = [
    {
        key: LocaleEnum.English,
        value: "English",
        label: "English",
        stripeShortLocale: 'en',
        nativeLanguageLabel: 'English',
    },
    {
        key: LocaleEnum.Polish,
        value: "Polish",
        label: "Polish",
        stripeShortLocale: 'pl',
        nativeLanguageLabel: 'Polski',
    },
    {
        key: LocaleEnum.Spanish,
        value: "Spanish",
        label: "Spanish",
        stripeShortLocale: 'es',
        nativeLanguageLabel: 'Española',
    },
    {
        key: LocaleEnum.German,
        value: "German",
        label: "German",
        stripeShortLocale: 'de',
        nativeLanguageLabel: 'Deutsch',
    },
    {
        key: LocaleEnum.Italian,
        value: "Italian",
        label: "Italian",
        stripeShortLocale: 'it',
        nativeLanguageLabel: 'Italiano',
    },
    {
        key: LocaleEnum.French,
        value: "French",
        label: "French",
        stripeShortLocale: 'fr',
        nativeLanguageLabel: 'Français',
    },
    {
        key: LocaleEnum.Portuguese_Portugal,
        value: "Portuguese_Portugal",
        label: "Portuguese_Portugal",
        stripeShortLocale: 'pt',
        nativeLanguageLabel: 'Português (PT)',
    },
    {
        key: LocaleEnum.Portuguese_Brazil,
        value: "Portuguese_Brazil",
        label: "Portuguese_Brazil",
        stripeShortLocale: 'pt-BR',
        nativeLanguageLabel: 'Português (BR)',
    },
] as const

export type LocaleEnumDataEntry = typeof LocaleEnumData[LocaleEnum]
export type LocaleEnumListEntry = typeof LocaleEnumList[number]
export type LocaleEnumListType = typeof LocaleEnumList

export interface LocalizerDataInterface {
    translation: string,
}

export type LocalizerDataType = Record<TextTokenEnum, LocalizerDataInterface>

export const LocalizerPortuguese_BrazilData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Todos os direitos reservados",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Quer ter a sua própria página de agendamento na TinyCal?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Clique aqui",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Selecione um serviço",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Selecione um membro da equipe",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "minutos",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Mostrar menos datas",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Mostrar mais datas",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Até",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "reuniões recorrentes",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Selecione uma data e horário",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Serviços",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Membro da equipe",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Data e horário",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Confirmação",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Reunião confirmada",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "DOM",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "SEG",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "TER",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "QUA",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "QUI",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "SEX",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SÁB",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Janeiro",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Fevereiro",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "Março",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "Abril",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Maio",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Junho",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Julho",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "Agosto",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "Setembro",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Outubro",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "Novembro",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Dezembro",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Continuar",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Confirmar detalhes do agendamento",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Entrar com o Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Nome",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "E-mail",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Número de reservas",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Observações",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Local",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Agendar reunião",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Perguntas",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Detalhes do pagamento",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Moeda",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Total",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Salvar método de pagamento",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Salvar este método de pagamento para uso futuro",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Telefone",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "Presencial (Definido pelo anfitrião)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "Presencial (Definido pelo participante)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "País",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Telefone (somente números)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Endereço",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Reunião agendada com sucesso",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Você pode encontrar os detalhes abaixo",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "Precisa reagendar ou cancelar esta reunião",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Remarcar ou cancelar reunião",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Agendada",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Recorrente",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Paga",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Grupo",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Reembolsada",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Reunião",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "minutos",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "vazio",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Remarcar",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Cancelar",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Cancelar todas as reuniões",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Tem certeza de que deseja cancelar a reunião?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Esta ação é irreversível.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Sim, cancelar",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Remarcar reunião",
    },
}

export const LocalizerPolishData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Wszelkie prawa zastrzeżone",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Chcesz mieć własną stronę rezerwacji TinyCal?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Kliknij tutaj",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Wybierz usługę",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Wybierz członka zespołu",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "minut",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Pokaż mniej dat",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Pokaż więcej dat",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Do",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "powtarzających się spotkań",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Wybierz datę i godzinę",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Usługi",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Członek zespołu",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Data i godzina",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Potwierdzenie",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Spotkanie potwierdzone",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "ND",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "PON",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "WT",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "ŚR",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "CZW",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "PT",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SOB",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Styczeń",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Luty",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "Marzec",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "Kwiecień",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Maj",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Czerwiec",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Lipiec",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "Sierpień",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "Wrzesień",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Październik",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "Listopad",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Grudzień",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Kontynuować",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Potwierdź szczegóły spotkania",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Zaloguj się przez Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Imię i nazwisko",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "Adres e-mail",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Liczba rezerwacji",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Notatki",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Lokalizacja",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Zarezerwuj spotkanie",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Pytania",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Dane płatności",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Waluta",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Razem",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Zapisz metodę płatności",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Zapisz tę metodę płatności do wykorzystania w przyszłości",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Telefon",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "Osobiście (lokalizacja gospodarza)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "Osobiście (lokalizacja uczestnika)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "Kraj",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Telefon (tylko numery)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Adres",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Spotkanie zostało pomyślnie zarezerwowane",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Szczegóły znajdziesz poniżej",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "Musisz przełożyć lub odwołać to spotkanie",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Zmień termin lub anuluj spotkanie",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Zaplanowane",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Cykliczne",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Opłacone",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Grupa",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Zwrócone",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Spotkanie",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "min",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "puste",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Zmień termin",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Anuluj",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Anuluj wszystkie spotkania",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Czy na pewno chcesz anulować spotkanie?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Ta czynność jest nieodwracalna.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Tak, anuluj",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Zmień termin spotkania",
    },
}

export const LocalizerGermanData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Alle Rechte vorbehalten",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Möchten Sie Ihre eigene TinyCal-Buchungsseite?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Klicken Sie hier",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Wählen Sie eine Dienstleistung",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Wählen Sie ein Teammitglied",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "Minuten",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Weniger Termine anzeigen",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Mehr Termine anzeigen",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Bis zu",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "wiederkehrende Meetings",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Datum und Uhrzeit auswählen",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Dienstleistungen",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Teammitglied",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Datum und Uhrzeit",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Bestätigung",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Termin bestätigt",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "SO",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "MO",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "DI",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "MI",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "DO",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "FR",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SA",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Januar",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Februar",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "März",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "April",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Mai",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Juni",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Juli",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "August",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "September",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Oktober",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "November",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Dezember",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Weiter",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Meetingdetails bestätigen",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Mit Google anmelden",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Name",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "E-Mail",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Anzahl der Buchungen",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Notizen",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Ort",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Meeting buchen",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Fragen",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Zahlungsdetails",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Währung",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Gesamtbetrag",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Zahlungsmethode speichern",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Diese Zahlungsmethode für zukünftige Nutzung speichern",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Telefon",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "Persönlich (vom Gastgeber festgelegt)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "Persönlich (vom Teilnehmer festgelegt)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "Land",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Telefon (nur Nummern)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Adresse",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Meeting erfolgreich gebucht",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Details finden Sie unten",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "Meeting verschieben oder stornieren",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Termin verschieben oder absagen",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Geplant",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Wiederkehrend",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Bezahlt",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Gruppe",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Erstattet",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Termin",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "Minuten",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "leer",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Verschieben",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Abbrechen",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Alle Termine absagen",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Sind Sie sicher, dass Sie den Termin absagen möchten?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Diese Aktion ist endgültig.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Ja, abbrechen",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Termin verschieben",
    },
}

export const LocalizerEnglishData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "All rights reserved",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Want your own TinyCal booking page?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Click here",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Select a service",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Select a team member",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "minutes",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Show less dates",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Show more dates",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Up to",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "recurring meetings",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Select a date and time",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Services",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Team Member",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Date and Time",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Confirmation",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Meeting Confirmed",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "SUN",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "MON",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "TUE",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "WED",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "THU",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "FRI",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SAT",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "January",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "February",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "March",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "April",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "May",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "June",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "July",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "August",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "September",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "October",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "November",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "December",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Continue",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Confirm meeting details",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Login with Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Name",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "Email",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Number of bookings",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Notes",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Location",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Book Meeting",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Questions",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Payment details",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Currency",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Total",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Save payment method",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Save this payment method for future usage",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Phone",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "In Person (Host Defined)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "In Person (Attendee Defined)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "Country",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Phone (only numbers)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Address",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Meeting successfully booked",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "You can find the details below",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "Need to reschedule or cancel this meeting",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Reschedule or cancel meeting",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Scheduled",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Recurring",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Paid",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Group",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Refunded",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Meeting",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "mins",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "empty",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Reschedule",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Cancel",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Cancel All Meetings",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Are you sure you want to cancel the meeting?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "This action is irreversible.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Yes, cancel",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Reschedule Meeting",
    },
}

export const LocalizerPortuguese_PortugalData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Todos os direitos reservados",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Deseja a sua própria página de reservas TinyCal?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Clique aqui",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Selecione um serviço",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Selecione um membro da equipa",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "minutos",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Mostrar menos datas",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Mostrar mais datas",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Até",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "reuniões recorrentes",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Selecione uma data e hora",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Serviços",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Membro da equipa",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Data e hora",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Confirmação",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Reunião confirmada",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "DOM",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "SEG",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "TER",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "QUA",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "QUI",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "SEX",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SÁB",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Janeiro",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Fevereiro",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "Março",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "Abril",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Maio",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Junho",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Julho",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "Agosto",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "Setembro",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Outubro",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "Novembro",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Dezembro",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Continuar",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Confirmar os detalhes da reunião",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Entrar com o Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Nome",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "E-mail",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Número de reservas",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Observações",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Local",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Agendar reunião",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Perguntas",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Detalhes do pagamento",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Moeda",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Total",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Guardar método de pagamento",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Guardar este método de pagamento para uso futuro",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Telefone",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "Presencial (Definido pelo anfitrião)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "Presencial (Definido pelo participante)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "País",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Telefone (apenas números)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Endereço",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Reunião agendada com sucesso",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Pode encontrar os detalhes abaixo",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "Necessita de reagendar ou cancelar esta reunião",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Remarcar ou cancelar reunião",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Agendada",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Recorrente",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Paga",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Grupo",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Reembolsada",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Reunião",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "minutos",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "vazio",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Remarcar",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Cancelar",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Cancelar todas as reuniões",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Tem a certeza de que pretende cancelar a reunião?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Esta ação é irreversível.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Sim, cancelar",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Remarcar reunião",
    },
}

export const LocalizerFrenchData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Tous droits réservés",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Vous souhaitez créer votre propre page de réservation TinyCal ?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Cliquez ici",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Sélectionnez un service",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Sélectionnez un membre de l'équipe",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "Minutes",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Afficher moins de dates",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Afficher plus de dates",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Jusqu'à",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "Réunions récurrentes",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Sélectionnez une date et une heure",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Services",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Membre de l'équipe",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Date et heure",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Confirmation",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Réunion confirmée",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "DIM",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "LUN",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "MAR",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "MER",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "JEU",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "VEN",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SAM",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Janvier",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Février",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "Mars",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "Avril",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Mai",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Juin",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Juillet",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "Août",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "Septembre",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Octobre",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "Novembre",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Décembre",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Continuer",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Confirmer les détails de la réunion",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Se connecter avec Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Nom",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "Adresse e-mail",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Nombre de réservations",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Remarques",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Lieu",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Réserver une réunion",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Questions",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Détails du paiement",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Devise",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Total",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Enregistrer le mode de paiement",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Enregistrer ce mode de paiement pour une utilisation ultérieure",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Téléphone",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "En présentiel (organisateur)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "En présentiel (participant)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "Pays",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Téléphone (numéros uniquement)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Adresse",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Réunion réservée avec succès",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Vous trouverez les détails ci-dessous",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "Reporter ou annuler cette réunion",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Reporter ou annuler la réunion",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Planifiée",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Récurrente",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Payée",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Groupe",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Remboursée",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Durée de la réunion",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "min",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "vide",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Reporter",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Annuler",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Annuler toutes les réunions",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Êtes-vous sûr de vouloir annuler la réunion ?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Cette action est irréversible.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Oui, annuler",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Reporter la réunion",
    },
}

export const LocalizerSpanishData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Reservados todos los derechos",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "¿Quieres tu propia página de reservas de TinyCal?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Haz clic aquí",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Selecciona un servicio",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Selecciona un miembro del equipo",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "minutos",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Mostrar menos fechas",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Mostrar más fechas",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Hasta",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "reuniones recurrentes",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Selecciona una fecha y hora",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Servicios",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Miembro del equipo",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Fecha y hora",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Confirmación",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Reunión confirmada",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "DOM",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "LUN",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "MAR",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "MIÉ",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "JUE",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "VIE",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SÁB",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Enero",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Febrero",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "Marzo",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "Abril",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Mayo",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Junio",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Julio",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "Agosto",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "Septiembre",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Octubre",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "Noviembre",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Diciembre",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Continuar",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Confirmar detalles de la reunión",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Iniciar sesión con Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Nombre",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "Correo electrónico",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Número de reservas",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Notas",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Ubicación",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Reservar reunión",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Preguntas",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Datos de pago",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Moneda",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Total",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Guardar método de pago",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Guardar este método de pago para futuras consultas",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Teléfono",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "Presencial (según el anfitrión)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "Presencial (según el asistente)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "País",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Teléfono (solo números)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Dirección",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Reunión reservada correctamente",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Puede encontrar los detalles a continuación",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "¿Necesita reprogramar o cancelar esta reunión?",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Reprogramar o cancelar reunión",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Programada",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Recurrente",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Pagada",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Grupo",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Reembolsada",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Reunión",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "minutos",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "vacío",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Reprogramar",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Cancelar",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Cancelar todas las reuniones",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "¿Seguro que desea cancelar la reunión?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Esta acción es irreversible.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Sí, cancelar",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Reprogramar reunión",
    },
}

export const LocalizerItalianData: LocalizerDataType = {
    [TextTokenEnum.AllRightsReserved]: {
        translation: "Tutti i diritti riservati",
    },
    [TextTokenEnum.BookingForm_WantYourOwnTinyCalBookingPage]: {
        translation: "Vuoi la tua pagina di prenotazione TinyCal?",
    },
    [TextTokenEnum.BookingForm_ClickHere]: {
        translation: "Clicca qui",
    },
    [TextTokenEnum.BookingForm_SelectAService]: {
        translation: "Seleziona un servizio",
    },
    [TextTokenEnum.BookingForm_SelectATeamMember]: {
        translation: "Seleziona un membro del team",
    },
    [TextTokenEnum.BookingForm_Minutes]: {
        translation: "minuti",
    },
    [TextTokenEnum.BookingForm_ShowLessDates]: {
        translation: "Mostra meno date",
    },
    [TextTokenEnum.BookingForm_ShowMoreDates]: {
        translation: "Mostra più date",
    },
    [TextTokenEnum.BookingForm_UpTo]: {
        translation: "Fino a",
    },
    [TextTokenEnum.BookingForm_RecurringMeetings]: {
        translation: "riunioni ricorrenti",
    },
    [TextTokenEnum.BookingForm_SelectADateAndTime]: {
        translation: "Seleziona una data e un'ora",
    },
    [TextTokenEnum.BookingForm_PageTitle_Services]: {
        translation: "Servizi",
    },
    [TextTokenEnum.BookingForm_PageTitle_TeamMember]: {
        translation: "Membro del team",
    },
    [TextTokenEnum.BookingForm_PageTitle_DateAndTime]: {
        translation: "Data e ora",
    },
    [TextTokenEnum.BookingForm_PageTitle_Confirmation]: {
        translation: "Conferma",
    },
    [TextTokenEnum.BookingForm_PageTitle_MeetingConfirmed]: {
        translation: "Riunione confermata",
    },
    [TextTokenEnum.BookingForm_SUN]: {
        translation: "DOM",
    },
    [TextTokenEnum.BookingForm_MON]: {
        translation: "LUN",
    },
    [TextTokenEnum.BookingForm_TUE]: {
        translation: "MAR",
    },
    [TextTokenEnum.BookingForm_WED]: {
        translation: "MER",
    },
    [TextTokenEnum.BookingForm_THU]: {
        translation: "GIO",
    },
    [TextTokenEnum.BookingForm_FRI]: {
        translation: "VEN",
    },
    [TextTokenEnum.BookingForm_SAT]: {
        translation: "SAB",
    },
    [TextTokenEnum.BookingForm_January]: {
        translation: "Gennaio",
    },
    [TextTokenEnum.BookingForm_February]: {
        translation: "Febbraio",
    },
    [TextTokenEnum.BookingForm_March]: {
        translation: "Marzo",
    },
    [TextTokenEnum.BookingForm_April]: {
        translation: "Aprile",
    },
    [TextTokenEnum.BookingForm_May]: {
        translation: "Maggio",
    },
    [TextTokenEnum.BookingForm_June]: {
        translation: "Giugno",
    },
    [TextTokenEnum.BookingForm_July]: {
        translation: "Luglio",
    },
    [TextTokenEnum.BookingForm_August]: {
        translation: "Agosto",
    },
    [TextTokenEnum.BookingForm_September]: {
        translation: "Settembre",
    },
    [TextTokenEnum.BookingForm_October]: {
        translation: "Ottobre",
    },
    [TextTokenEnum.BookingForm_November]: {
        translation: "Novembre",
    },
    [TextTokenEnum.BookingForm_December]: {
        translation: "Dicembre",
    },
    [TextTokenEnum.BookingForm_Continue]: {
        translation: "Continua",
    },
    [TextTokenEnum.BookingForm_ConfirmMeetingDetails]: {
        translation: "Conferma i dettagli della riunione",
    },
    [TextTokenEnum.BookingForm_LoginWithGoogle]: {
        translation: "Accedi con Google",
    },
    [TextTokenEnum.BookingForm_Name]: {
        translation: "Nome",
    },
    [TextTokenEnum.BookingForm_Email]: {
        translation: "Email",
    },
    [TextTokenEnum.BookingForm_NumberOfBookings]: {
        translation: "Numero di prenotazioni",
    },
    [TextTokenEnum.BookingForm_Notes]: {
        translation: "Note",
    },
    [TextTokenEnum.BookingForm_Location]: {
        translation: "Luogo",
    },
    [TextTokenEnum.BookingForm_BookMeeting]: {
        translation: "Prenota riunione",
    },
    [TextTokenEnum.BookingForm_Questions]: {
        translation: "Domande",
    },
    [TextTokenEnum.BookingForm_PaymentDetails]: {
        translation: "Dettagli di pagamento",
    },
    [TextTokenEnum.BookingForm_Currency]: {
        translation: "Valuta",
    },
    [TextTokenEnum.BookingForm_Total]: {
        translation: "Totale",
    },
    [TextTokenEnum.BookingForm_SavePaymentMethod]: {
        translation: "Salva metodo di pagamento",
    },
    [TextTokenEnum.BookingForm_SaveThisPaymentMethodForFutureUsage]: {
        translation: "Salva questo metodo di pagamento per un utilizzo futuro",
    },
    [TextTokenEnum.BookingForm_GoogleMeet]: {
        translation: "Google Meet",
    },
    [TextTokenEnum.BookingForm_Zoom]: {
        translation: "Zoom",
    },
    [TextTokenEnum.BookingForm_Phone]: {
        translation: "Telefono",
    },
    [TextTokenEnum.BookingForm_InPersonHostDefined]: {
        translation: "Di persona (definito dall'organizzatore)",
    },
    [TextTokenEnum.BookingForm_InPersonAttendeeDefined]: {
        translation: "Di persona (definito dal partecipante)",
    },
    [TextTokenEnum.BookingForm_Country]: {
        translation: "Paese",
    },
    [TextTokenEnum.BookingForm_PhoneOnlyNumbers]: {
        translation: "Telefono (solo numeri)",
    },
    [TextTokenEnum.BookingForm_Address]: {
        translation: "Indirizzo",
    },
    [TextTokenEnum.BookingForm_MeetingSuccessfullyBooked]: {
        translation: "Riunione prenotata con successo",
    },
    [TextTokenEnum.BookingForm_YouCanFindTheDetailsBelow]: {
        translation: "Puoi trovare i dettagli di seguito",
    },
    [TextTokenEnum.BookingForm_NeedToRescheduleOrCancelThisMeeting]: {
        translation: "È necessario riprogrammare o annullare questa riunione",
    },
    [TextTokenEnum.Meeting_RescheduleOrCancelMeeting]: {
        translation: "Ripianifica o annulla riunione",
    },
    [TextTokenEnum.Meeting_Scheduled]: {
        translation: "Pianificata",
    },
    [TextTokenEnum.Meeting_Recurring]: {
        translation: "Ricorrente",
    },
    [TextTokenEnum.Meeting_Paid]: {
        translation: "Pagata",
    },
    [TextTokenEnum.Meeting_Group]: {
        translation: "Gruppo",
    },
    [TextTokenEnum.Meeting_Refunded]: {
        translation: "Rimborsata",
    },
    [TextTokenEnum.Meeting_Meeting]: {
        translation: "Riunione",
    },
    [TextTokenEnum.Meeting_Mins]: {
        translation: "minuti",
    },
    [TextTokenEnum.Meeting_empty]: {
        translation: "vuoto",
    },
    [TextTokenEnum.Meeting_Reschedule]: {
        translation: "Ripianifica",
    },
    [TextTokenEnum.Meeting_Cancel]: {
        translation: "Annulla",
    },
    [TextTokenEnum.Meeting_CancelAllMeetings]: {
        translation: "Annulla tutte le riunioni",
    },
    [TextTokenEnum.Meeting_AreYouSureYouWantToCancelTheMeeting]: {
        translation: "Sei sicuro di voler annullare la riunione?",
    },
    [TextTokenEnum.Meeting_ThisActionIsIrreversible]: {
        translation: "Questa azione è irreversibile.",
    },
    [TextTokenEnum.Meeting_YesCancel]: {
        translation: "Sì, annulla",
    },
    [TextTokenEnum.Meeting_RescheduleMeeting]: {
        translation: "Ripianifica riunione",
    },
}
